import React, { useEffect, useState, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { Alert } from '@material-ui/lab';
import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  Collapse,
  CircularProgress,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutline';

import api from 'src/services/api';
import { GET_MESSAGE_STATUS_OF_TRIBUTE } from 'src/utils/messages';

import { useStyles } from './styles';

export function ServicoDetalhe() {
  const classes = useStyles();

  const history = useHistory();
  const { state, pathname } = useLocation();

  const usuario = useSelector((state) => state.user);

  const { servico, message } = state;

  const [statusServico, setStatusServico] = useState(0);
  const [loadingStatus, setLoadingStatus] = useState(true);
  const [alertMessage, setAlertMessage] = useState(!!message);

  useEffect(() => {
    const getStatusServico = async () => {
      try {
        setLoadingStatus(true);

        const response = await api.post('/statusServico', {
          id_usuario: usuario.id,
          id_servico: servico.id,
        });

        setStatusServico(response?.data?.status);
      } catch (error) {
        //
      } finally {
        setLoadingStatus(false);
      }
    };

    getStatusServico();
  }, [usuario, servico, message]);

  const isButtonDisabled = useMemo(() => {
    if (statusServico === 1) {
      return true;
    }

    if (!usuario.hasSignature && servico?.necessario_assinatura) {
      return true;
    }

    if (servico?.nome.includes('Abertura') && usuario.hasCompany) {
      return true;
    }

    if (
      (servico?.uuid === '0f36236d-e234-4656-a6e8-6ea2ac5dcf8d' ||
        servico?.uuid === 'd490cb59-db44-4a6b-87b9-07a285d79236') &&
      usuario.existsProcessOpenCompany
    ) {
      return true;
    }

    return false;
  }, [
    servico,
    statusServico,
    usuario.existsProcessOpenCompany,
    usuario.hasCompany,
    usuario.hasSignature,
  ]);

  const handleContratarClick = () => {
    history.push({
      pathname: `${pathname}/formasPagamento`,
      state: {
        servico,
      },
    });
  };

  const renderStatus = () => {
    if (statusServico > 0) {
      const { color, mensage } = GET_MESSAGE_STATUS_OF_TRIBUTE[statusServico];

      return (
        <div className={classes.paymentInfo}>
          <Typography variant="body1">SITUAÇÃO</Typography>
          <Typography variant="body1" style={{ color }}>
            {mensage}
          </Typography>
        </div>
      );
    }
  };

  return (
    <Box className={classes.root}>
      <Card variant="outlined">
        <CardContent>
          <Collapse in={alertMessage}>
            <Alert severity="info" onClose={() => setAlertMessage(false)}>
              {message}
            </Alert>
          </Collapse>
          <Typography gutterBottom variant="h5" component="h2">
            {servico.nome}
          </Typography>
          <Typography variant="body2" component="p">
            {servico.descricao}
          </Typography>

          {servico?.documentos_necessario_servicos?.length > 0 && (
            <Box mt={2}>
              <Typography variant="subtitle1">
                Documentação necessária:
              </Typography>
              <List className={classes.listOfDocuments}>
                {servico.documentos_necessario_servicos.map((documento) => (
                  <ListItem key={documento?.id_documento_necessario}>
                    <CheckCircleIcon className={classes.iconDocument} />
                    <ListItemText
                      primary={documento?.DocumentoNecessario?.nome}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}

          <div className={classes.paymentInfo}>
            <Typography variant="body1">VALOR</Typography>
            <Typography variant="body1">{`R$ ${servico.valor}`}</Typography>
          </div>

          <div className={classes.paymentInfo}>
            <Typography variant="body1">FORMA DE PAGAMENTO</Typography>
            <Typography variant="body1">{servico.stringParcela}</Typography>
          </div>

          {renderStatus()}

          {!usuario.hasSignature && servico?.necessario_assinatura && (
            <Box mt={2}>
              <Alert severity="warning">
                Para contratar este serviço é preciso ter uma assinatura ativa.
              </Alert>
            </Box>
          )}
        </CardContent>

        <div className={classes.buttonContainer}>
          <Button
            onClick={handleContratarClick}
            size="medium"
            variant="contained"
            color="primary"
            disabled={isButtonDisabled || loadingStatus}
          >
            {loadingStatus ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              'Contratar'
            )}
          </Button>
        </div>
      </Card>
    </Box>
  );
}

export default ServicoDetalhe;
